import SectionViewSwitch, { Props as ImportedProps } from './SectionViewSwitch';
export default SectionViewSwitch;
export type Props = ImportedProps;
